import { EndowContainer } from "../../containers";
import "./style.scss";
function Endow() {
  return (
    <div id="endowPage">
      <EndowContainer />
    </div>
  );
}
export default Endow;
